import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import AuthService from "../services/auth.service";
import api from "../services/api";
import MilkPreview from "./MilkPreview";
import MilkDetail from "./MilkDetail";
import Modal from "./UI/Modal";
import MilkChart from "./veauHub/MilkChart";

function Milk() {
    const [milks, setMilks] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [calf, setCalf] = useState({});
    const [isLoading, setLoading] = useState(true);
    const navigate = useNavigate();
    let { calfId } = useParams();
    let [isUpdateModalOpen, setisUpdateModalOpen] = useState(false);
    let [selectedMilk, setSelectedMilk] = useState(0);

    function closeUpdateModal() {
        setisUpdateModalOpen(false);
    }


    const getMilk = () => {
        api
            .get("/milk/calf/" + calfId)
            .then((response) => {
                const data = response.data;
                setMilks(data.milk);
                setTotalQuantity(data.totalQuantity);
                getCalf();
            })
            .catch((error) => {
                console.error("There was an error getting the milk", error);
            });
    };

    const getCalf = () => {
        api
            .get("/calfs/" + calfId)
            .then((response) => {
                const data = response.data;
                setCalf(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("There was an error getting the calf", error);
            });
    };

    const refresh = () => {
        setMilks([]);
        getCalf();
        getMilk();
    };

    useEffect(() => {
        const currentUser = AuthService.getCurrentUser();
        if (!currentUser) {
            navigate("/login");
        } else {
            getMilk();
        }
    }, []);

    if (isLoading) {
        return <div></div>;
    }

    return (
        <div className="md:bg-white dark:md:bg-slate-900">
            <div className={milks.length === 0 ? "hidden" : ""}>
                <div className={"flex flex-row justify-end md:hidden"}>
                    <Link to={"/nouveau_lait/" + calfId}>
                        <span className="font-medium text-amber-500 dark:text-amber-400">Ajouter du lait</span>
                    </Link>
                </div>
                <MilkChart milks={milks} totalQuantity={totalQuantity} />
                <div className="mt-3 w-full overflow-visible rounded-lg border-stone-200 bg-white md:mt-6 md:border md:shadow dark:border-slate-700 dark:bg-slate-900">
                    <div className="mb-3 hidden justify-between rounded-t-md border-b border-stone-200 p-6 text-stone-800 md:flex dark:border-slate-700 dark:text-white">
                        <span className="text-lg font-semibold">Liste des quantités de lait</span>
                        <Link to={"/nouveau_lait/" + calfId}>
                            <button className="flex items-center rounded-lg border border-stone-200 px-3 py-2 text-sm text-stone-800 shadow transition-all duration-100 hover:-translate-y-[2px] hover:shadow-lg dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="mr-2 h-4 w-4"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M12 4.5v15m7.5-7.5h-15"
                                    />
                                </svg>
                                <span>Ajouter</span>
                            </button>
                        </Link>
                    </div>
                    {milks.map((milk, index) => (
                        <MilkPreview
                            key={"milk_" + index}
                            calfID={calfId}
                            milk={milk}
                            milkID={milk.idmilk}
                            index={index}
                            listLength={milks.length}
                            setisUpdateModalOpen={setisUpdateModalOpen}
                            setSelectedMilk={setSelectedMilk}
                        ></MilkPreview>
                    ))}
                </div>
            </div>
            <div className={"mt-3 flex flex-col items-center justify-center " + (milks.length > 0 ? "hidden" : "")}>
                <div>
                    <span className="font-semibold dark:text-white">Aucune quantité de lait enregistrée</span>
                </div>
                <p className="my-3 text-center text-sm text-stone-400 dark:text-slate-400">
                    Vous n'avez encore enregistré aucune quantité de lait pour ce veau. Cliquer sur
                    "Ajouter du lait" pour commencer !
                </p>
                <Link to={"/nouveau_lait/" + calfId}>
                    <button className="rounded-lg bg-amber-400 py-1 px-3 text-white dark:bg-amber-500 dark:hover:bg-amber-600">
                        Ajouter du lait
                    </button>
                </Link>
            </div>
            <Modal
                open={isUpdateModalOpen}
                onClose={closeUpdateModal}
                title="Détail de la période"
            >
                <MilkDetail
                    milkId={selectedMilk}
                    onDeleted={() => {
                        closeUpdateModal();
                        refresh();
                    }}
                />
            </Modal>
        </div>
    );
}

export default Milk;